<template>
  <div class="repurchase-analysis">
    <div class="header-ctn">
      <div class="title-ctn">
        <span class="title">复购分析</span>
        <img src="~@/assets/questionTip.png" @click="showTooltip" />
      </div>
      <span class="header-right">每月累计</span>
    </div>
    <div class="desc">统计时间内，所有下单的顾客中，在本店下单两次及以上的顾客占比</div>
    <div class="hr" />
    <div class="card-panel-list">
      <div :class="activeCard === 1 ? 'selected' : ''" class="card-panel" @click="switchChart(1)">
        <div class="content">
          <div class="title">复购率</div>
          <div class="num">{{ repurchaseData.repurchaseRate || 0 }}%</div>
        </div>
      </div>
      <div :class="activeCard === 2 ? 'selected' : ''" class="card-panel" @click="switchChart(2)">
        <div class="content">
          <div class="title">复购人数</div>
          <div class="num">{{ repurchaseData.repurchaseCount || 0 }}</div>
        </div>
      </div>
      <div :class="activeCard === 3 ? 'selected' : ''" class="card-panel" @click="switchChart(3)">
        <div class="content">
          <div class="title">复购销售额</div>
          <div class="num">¥{{ repurchaseData.repurchaseAmount || 0 }}</div>
        </div>
      </div>
    </div>
    <div class="repurchase-chart">
      <template v-if="chartData.data">
        <line-chart ref="chart" :chart-data="chartData" />
      </template>
      <template v-else>
        <div class="empty-ctn">
          <div class="empty-img">
            <img src="~@/assets/empty.png" />
          </div>
          <div class="no-text">暂无数据</div>
        </div>
      </template>
    </div>
    <van-popup v-model="showTip" round position="bottom" :style="{ height: '40%' }">
      <div class="tip-container">
        <p class="tip"><span>复购率：</span>统计时间内，所有下单的顾客中，在本店下单两次及以上的顾客占比</p>
        <p class="tip"><span>复购人数：</span>统计时间内，在本店下单两次以上的顾客数</p>
        <p class="tip"><span>复购销售额：</span>统计时间内，在本店下单两次以上的顾客带来的的销售额同pos端传入的订单【实收金额】合计，扣去已经退款的金额</p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getRepurchaseDataStat } from '@/api/robot'
import LineChart from './LineChart'
export default {
  components: {
    LineChart
  },
  data() {
    return {
      activeCard: 1, // 1: '复购率', 2: '复购人数', 3: '复购销售额'
      showTip: false,
      repurchaseData: {
        repurchaseRate: 0, // 复购率
        repurchaseCount: 0, // 复购人数
        repurchaseAmount: 0, // 复购销售额
        recRateTrend: null, // 复购率图表
        recPerTrend: null, // 复购人数图表
        recAmountTrend: null // 复购销售额图表
      },
      chartData: {
        type: 'repurchase',
        cardType: 1,
        data: null
      },
      loading: false
    }
  },
  computed: {},
  created() {
    this.getRepurchaseDataStat()
  },
  methods: {
    resizeChart() {
      if (this.$refs.chart && this.$refs.chart.chart) {
        this.$refs.chart.chart.resize()
      }
    },
    switchChart(type) {
      if (this.activeCard === type) return
      this.activeCard = type
      this.setChartData()
    },
    showTooltip() {
      this.showTip = true
    },
    setChartData() {
      const cardType = this.activeCard
      let data = null
      if (cardType === 1) {
        data = this.repurchaseData.recRateTrend
      } else if (cardType === 2) {
        data = this.repurchaseData.recPerTrend
      } else if (cardType === 3) {
        data = this.repurchaseData.recAmountTrend
      }
      this.chartData = {
        type: 'repurchase',
        cardType,
        data
      }
    },
    async getRepurchaseDataStat() {
      try {
        this.loading = true
        const res = await getRepurchaseDataStat({})
        this.repurchaseData = res
        this.chartData = {
          ...this.chartData,
          data: this.repurchaseData.recRateTrend
        }
        this.loading = false
      } catch (e) {
        this.loading = false
        console.log('getRepurchaseDataStat', e)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.repurchase-analysis {
  min-height: 542px;
  background: #ffffff;
  box-shadow: 0 0 12px 0 rgba(48, 48, 60, 0.08);
  border-radius: 4px;
  padding: 20px 14px 0 14px;
  .header-ctn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title-ctn {
      font-family: PingFangSC-Medium;
      font-size: 18px;
      color: #333333;
    }
    .header-right {
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #999999;
    }
    img {
      width: 15px;
      height: 15px;
      padding-left: 6px;
      padding-right: 6px;
    }
  }
  .desc {
    font-family: PingFangSC-Regular;
    font-size: 11px;
    color: #999999;
    margin: 16px 0;
  }
  .hr {
    position: relative;
    border: none;
  }

  .hr:after {
    content: '';
    position: absolute;
    top: 0;
    background: #f3f3f3;
    width: 100%;
    height: 2px;
    transform: scaleY(0.5);
    transform-origin: 0 0;
  }
  .card-panel-list {
    padding: 20px 0;
    display: flex;
    .card-panel {
      box-sizing: border-box;
      width: 33.3%;
      height: 50px;
      border: 1px solid #dedfde;
      border-radius: 3px;
      padding-top: 6px;
      padding-left: 6px;
      margin-right: 6px;
      &.selected {
        background: rgba(70, 117, 240, 0.1);
        border: 1px solid #4675f0;
      }
      .title {
        font-family: PingFangSC-Regular;
        font-size: 11px;
        color: #999999;
        margin-bottom: 4px;
      }
      .num {
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #333333;
      }
    }
  }
  .repurchase-chart {
    margin-top: 16px;
  }
}
</style>
